var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "450px",
        "show-close": false,
        visible: _vm.visible,
        "destroy-on-close": "",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _vm.isProceedShipment
        ? _c("div", { staticClass: "proceed-shipment" }, [
            _c(
              "div",
              {
                staticClass: "back_icon",
                on: {
                  click: function($event) {
                    _vm.visible = false
                  }
                }
              },
              [
                _c("i", { staticClass: "el-icon-arrow-left" }),
                _vm._v(" "),
                _c("span", [_vm._v("Proceed the shipment")])
              ]
            ),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n      The retailer confirms that the remaining products can be shipped, please check that the remaining products are not out of stock, and can be shipped all at once\n    "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "footer" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.submit }
                  },
                  [_vm._v("Submit")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "info",
                    on: {
                      click: function($event) {
                        _vm.visible = false
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                )
              ],
              1
            )
          ])
        : _c(
            "div",
            { staticClass: "refuse-fulfill" },
            [
              _c("p", [_vm._v("Reject order")]),
              _vm._v(" "),
              _c("div", [
                _vm._v("Reason for rejection "),
                _c("span", { staticStyle: { color: "#FB541C" } }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  maxlength: "200",
                  "show-word-limit": "",
                  placeholder: "Fill in the reason for refusal"
                },
                model: {
                  value: _vm.rejectionReason,
                  callback: function($$v) {
                    _vm.rejectionReason = $$v
                  },
                  expression: "rejectionReason"
                }
              }),
              _vm._v(" "),
              !_vm.rejectionReason
                ? _c("div", { staticClass: "required-error" }, [
                    _vm._v("Please enter rejection reason")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "tips" }, [
                _vm._v("This information was shown to retailer")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sync-sku" },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.isSyncSku,
                        callback: function($$v) {
                          _vm.isSyncSku = $$v
                        },
                        expression: "isSyncSku"
                      }
                    },
                    [
                      _vm._v(
                        "Synchronize setting the SKU items in the order as inactive."
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.submit }
                    },
                    [_vm._v("Submit")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "info",
                      on: {
                        click: function($event) {
                          _vm.visible = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  )
                ],
                1
              )
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a131ad0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a131ad0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/out-stock-confirm-dialog.vue
// module id = i4co
// module chunks = 2